import { InferOutput, maxValue, minValue, number, pipe } from 'valibot'

export const MobilityNumberSchema = pipe(number(), minValue(0), maxValue(32))

export type HasMobilityNumber = InferOutput<typeof MobilityNumberSchema>
